import api from '../../utils/api'

import { useState } from 'react'



/* Hooks */
import useFlashMessage from '../../hooks/useFlashMessage'

/* form */
import FormSimpleProduct from './Form/FormSimpleProduct'

function NewSimpleProduct({ btCancelAction, handleOnSuccess }) {
    const [token] = useState(localStorage.getItem('token') || '')
    const { setFlashMessage } = useFlashMessage()



    async function registerSimpleProduct(obj) {
        let msgType = 'success'

        const data = await api.post('/simpleProduct/new', obj, {
            headers: {
                Authorization: `Bearer ${JSON.parse(token)}`,
            },

        }).then((response) => {
            return response.data
        })
            .catch((err) => {
                msgType = 'error'
                return err.response.data
            })

        setFlashMessage(data.message, msgType)

        if (msgType !== 'error') {

            handleOnSuccess()
        }
    }

    return (
        <FormSimpleProduct title="Cadastrar Produto" handleSubmit={registerSimpleProduct} btCancelAction={btCancelAction} btnText="Cadastrar" />
    )
}

export default NewSimpleProduct
